export const AI_PACKAGE_ID = "PKG_AI_001";

export const AI_FEATURES = {
  "KC Tools": "kcTools",
  "Content Tools": "contentTools",
  "Course and Competency Tools": "courseCompetencyTools",
  "AI Assistant Bot": "aiAssistantBot",
  "Prompt Library": "promptLibrary",
  "Insights and Reporting": "insightsReporting",
  "Asynchronous Job Monitor": "asyncJobMonitor",
  "Resume Builder": "resumeBuilder",
  "Allow for switching models": "allowSwitchModels",
  "Teaching Checklist": "teachingChecklist",
};

export const AI_FEATURE_IDS = Object.fromEntries(
  Object.entries(AI_FEATURES).map(([featureId, key]) => [key, featureId]),
);

export const AI_PACKAGE_FEATURE_KEYS = Object.freeze({
  KC_TOOLS: "kcTools",
  CONTENT_TOOLS: "contentTools",
  COURSE_COMPETENCY_TOOLS: "courseCompetencyTools",
  AI_ASSISTANT_BOT: "aiAssistantBot",
  PROMPT_LIBRARY: "promptLibrary",
  INSIGHTS_REPORTING: "insightsReporting",
  ASYNC_JOB_MONITOR: "asyncJobMonitor",
  RESUME_BUILDER: "resumeBuilder",
  ALLOW_SWITCH_MODELS: "allowSwitchModels",
  TEACHING_CHECKLIST: "teachingChecklist",
});

export const AI_PACKAGE_FLAGS = Object.freeze({
  createKC: "Create KC",
  customizeKC: "Customize KC",
  kcLearnerAnswerAnalysis: "KC Learner Answer Analysis",
  createNewContentFromCourseCompetencyMicroCompetency:
    "Create New Content from Course Structure",
  customizeExistingContentForCareer:
    "Customize Existing Course Content for a Career",
  createCompetencyAndMicroCompetencyDescriptions:
    "Create Competency and Micro Competency description using AI",
  createNewCompetencyTree: "Create a New Competency Tree",
  generateCourseContent: "Generate Course Content",
  showSourceReferences: "Show source references",
  shareConversationHistory: "Share conversation history",
  externalBot: "External Bot",
  enableForLearner: "Enable for Learner",
  enableForNonLearner: "Enable for Non Learner",
  viewPromptLibrary: "View Prompt Library",
  editPromptLibrary: "Edit Prompt Library",
  questionFeedbackInjection: "Question feedback injection",
  aiInsightsDashboard: "AI Insights Dashboard",
  viewProcessingStatus: "View Processing Status",
  learnerTool: "Learner Tool",
  podcastGeneration: "Podcast Generation",
  adminTool: "Admin Tool",
});


